<template>
  <div id="app"> 
    <Intro v-if="!mobile"></Intro>
    <IntroMobile v-else></IntroMobile>
    <Header></Header>
    <Projects></Projects>
    <!-- <Footer></Footer> -->
  </div>
</template>

<script>
import Intro from '../components/Intro';
import IntroMobile from '../components/IntroB';

import Header from '../components/Header';
import Projects from '../components/Projects';
// import Footer from '../components/Footer';

import { isMobile } from 'mobile-device-detect';

export default {
  name: 'App',
  components: {
    Intro,
    IntroMobile,
    Header,
    Projects,
    // Footer
  },
  data(){
    console.log(isMobile)
    return {
          camera: null,
          scene: null,
          renderer: null,
          shapes: [],
          cube: null,
          currentVisible: 0,
          lastVisible: 0,
          counter: 0, 
          mobile: isMobile
        }
  },
}
</script>

<style>
  #app{
      position: absolute;
      top: 0; 
      left: 0;
      overflow-x: hidden;
      width: 100%;
      height: 100%;
  }
  .footer{
    position: absolute;
    bottom: 0;
  }
</style>
